/** Placeholder like “Message in INV-002432” when an invoice # is available. */
export function messageComposerPlaceholder(matterOrInvoice, fallback = 'Write a message…') {
  const invoice =
    typeof matterOrInvoice === 'string' || typeof matterOrInvoice === 'number'
      ? String(matterOrInvoice || '').trim()
      : String(
          matterOrInvoice?.External_Invoice_ID ||
            matterOrInvoice?.Invoice_ID ||
            matterOrInvoice?.invoice ||
            ''
        ).trim();
  if (invoice) return `Message in ${invoice}`;
  return fallback;
}

/** Curated emoji set for attorney/client demand messaging. */
export const MESSAGE_EMOJI_OPTIONS = Object.freeze([
  '👍',
  '👎',
  '✅',
  '❗',
  '❓',
  '🙏',
  '😊',
  '🙂',
  '😅',
  '😮',
  '😢',
  '🙌',
  '📎',
  '📄',
  '💰',
  '📅',
  '⏰',
  '📍',
  '📞',
  '✉️',
  '🚀',
  '💡',
  '⚠️',
  '🔴',
  '🟢',
  '⚪',
]);

export function insertTextAtSelection(value, insert, selectionStart = 0, selectionEnd = 0) {
  const text = String(value || '');
  const start = Math.max(0, Math.min(Number(selectionStart) || 0, text.length));
  const end = Math.max(start, Math.min(Number(selectionEnd) || start, text.length));
  const next = `${text.slice(0, start)}${insert}${text.slice(end)}`;
  const caret = start + String(insert || '').length;
  return { value: next, selectionStart: caret, selectionEnd: caret };
}

export function getSpeechRecognitionConstructor() {
  if (typeof window === 'undefined') return null;
  return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

export function speechRecognitionSupported() {
  return Boolean(getSpeechRecognitionConstructor());
}

/**
 * Create a one-shot / continuous speech recognizer.
 * Returns null when the browser does not support Web Speech API.
 */
export function createSpeechRecognizer({
  onResult,
  onError,
  onEnd,
  continuous = true,
  interimResults = true,
  lang = typeof navigator !== 'undefined' ? navigator.language || 'en-US' : 'en-US',
} = {}) {
  const Ctor = getSpeechRecognitionConstructor();
  if (!Ctor) return null;
  const recognition = new Ctor();
  recognition.continuous = continuous;
  recognition.interimResults = interimResults;
  recognition.lang = lang;

  recognition.onresult = (event) => {
    let finalChunk = '';
    let interimChunk = '';
    for (let i = event.resultIndex; i < event.results.length; i += 1) {
      const result = event.results[i];
      const transcript = String(result?.[0]?.transcript || '');
      if (result.isFinal) finalChunk += transcript;
      else interimChunk += transcript;
    }
    onResult?.({ finalChunk, interimChunk, event });
  };

  recognition.onerror = (event) => {
    onError?.(event);
  };

  recognition.onend = () => {
    onEnd?.();
  };

  return recognition;
}
